import styled from "styled-components";

import Testimonials from "../../components/Organisms/Testimonials";

export const StyledTestimonials = styled(Testimonials)`
  padding: 56px 0 72px;
  @media only screen and (max-width: 1024px) {
    padding: 32px 0;
  }
  .slick-prev,
  .slick-next {
    top: -18px;
    @media only screen and (max-width: 1024px) {
      height: 20px;
      width: 20px;
    }
  }
  .slick-prev {
    @media only screen and (max-width: 1024px) {
      right: 38px;
    }
  }
`;
